import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { rejectDocument } from "../Services/vendorServices";

export const useRejectDocument = () => {
    const queryClient = useQueryClient();

    const mutation = useMutation({
        mutationFn: (payload) => rejectDocument(payload),
        onSuccess: () => {
            queryClient.invalidateQueries(["documents"]); // adjust key as needed
            toast.success("Rejection submitted successfully.");
        },
        onError: (err) => {
            toast.error(err?.response?.data?.status?.message ?? "Failed to reject document");
        },
    });

    return mutation; // return the whole mutation object (mutate, isLoading, etc.)
};

